import React from "react";
import { Helmet } from "react-helmet";
import { useLocation, matchPath, useNavigate } from "react-router-dom";
import { makeTitleFromBreadcrumbs } from "./utils";
import { getBreadcrumbsConfig } from "./config";
import { Breadcrumbs } from "@skyportal/ui-kit";

const ModuleBreadcrumbs = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const configItem = getBreadcrumbsConfig().find((item) =>
    matchPath(
      {
        path: item.match.path,
        caseSensitive: true,
        end: item.match.exact ?? true,
      },
      pathname
    )
  );

  if (!configItem) {
    return null;
  }

  const documentTitle = makeTitleFromBreadcrumbs(configItem);

  return (
    <>
      <Helmet>
        <title>{documentTitle}</title>
      </Helmet>
      <Breadcrumbs config={configItem} onBreadcrumbClick={navigate} />
    </>
  );
};

export default ModuleBreadcrumbs;
